import { FC } from "react";

import {
  PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE,
  PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW,
} from "./interaction-mode/helpers";

import { t } from "i18n/i18n";
import { Chip } from "mds/components/Chip";
import { IconText } from "mds/components/IconText";
import { Tooltip } from "mds/components/Tooltip";
import { LockLockedIcon } from "mds/icons";

export const PageLockedChip: FC<{ canAuthorSection: boolean }> = ({ canAuthorSection }) => {
  const tooltipText = canAuthorSection
    ? t("lock_status.page_locked_help")
    : t("lock_status.student_lock_warning");
  return (
    <Tooltip text={tooltipText}>
      <Chip kind="red">
        <IconText
          containerQueryClassNameHide={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE}
          containerQueryClassNameShow={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW}
          iconStart={<LockLockedIcon />}
          text={t("lock_status.locked")}
        />
      </Chip>
    </Tooltip>
  );
};
